// ** Initial State
const initialState = {
    allData: [],
    data: [],
    total: 1,
    params: {},
    selectedUser: null
  }
  
  const usersMetas = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_ALL_DATA_METAS':
        return { ...state, allData: action.data }
      case 'GET_DATA_METAS':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
          params: action.params
        }
      case 'GET_USER_METAS':
        return { ...state, selectedUser: action.selectedUser }
      case 'ADD_USER_METAS':
        return { ...state }
      case 'DELETE_USER_METAS':
        return { ...state }
      default:
        return { ...state }
    }
  }
  export default usersMetas
  